import React from 'react';
import { useInView } from 'react-intersection-observer';
import '../styles/About.css';

const About = () => {
  const { ref: headerRef, inView: headerInView } = useInView({ triggerOnce: true, threshold: 0.2 });
  const { ref: contentRef, inView: contentInView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section id="about" className="about-section section-spacing">
      <div className="container-custom">
        <div className="about-grid">
          <div className="about-image-wrapper">
            <div className="about-image-placeholder" style={{ backgroundImage: 'url(/images/About.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              <div className="image-overlay"></div>
              <div className="about-badge">
                <span>2023</span>
                <p>Fundação</p>
              </div>
            </div>
          </div>

          <div className="about-content">
            <div ref={headerRef} className={`about-header ${headerInView ? 'visible' : ''}`}>
              <h2 className="section-title">Nossa Jornada</h2>
              <div className="divider"></div>
            </div>

            <div ref={contentRef} className={`about-text ${contentInView ? 'visible' : ''}`}>
              <p className="about-intro">
                Em 2023, <strong>Daniele Araújo</strong> fundou a Tratty Professionals,
                uma empresa comprometida em entregar resultados por meio de composições
                cuidadosamente escolhidas, unindo ativos tecnológicos, naturais e sustentáveis.
              </p>

              <p>
                Com uma década de experiência como gerente comercial no ramo profissional,
                Daniele desenvolveu uma aptidão única e uma paixão pela busca dos melhores
                produtos, adaptando-se às diversas estruturas capilares em um país tão
                miscigenado como o nosso.
              </p>

              <p>
                Essa trajetória única, combinada com a profunda compreensão das variadas
                necessidades dos fios capilares, moldou a Tratty como uma marca que não apenas
                transforma esteticamente, mas também fortalece e revitaliza os cabelos.
              </p>

              <div className="about-values">
                <div className="value-item">
                  <div className="value-icon">
                    <div className="icon-circle"></div>
                  </div>
                  <h4>Inovação</h4>
                  <p>Fórmulas com ácido lático, ácido glioxílico e blend de aminoácidos</p>
                </div>

                <div className="value-item">
                  <div className="value-icon">
                    <div className="icon-circle"></div>
                  </div>
                  <h4>Sustentabilidade</h4>
                  <p>Práticas sustentáveis e embalagens ecológicas</p>
                </div>

                <div className="value-item">
                  <div className="value-icon">
                    <div className="icon-circle"></div>
                  </div>
                  <h4>Qualidade</h4>
                  <p>Ingredientes selecionados e testados para máxima eficácia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
